import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * One-tap "Add" for the basket suggestions (snippets/cc-cart-upsell.liquid).
 * Loaded from the head because the drawer's HTML is re-rendered on every cart
 * change and scripts inside it would never run.
 */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-upsell-variant]');
  if (!btn || btn.disabled) return;
  btn.disabled = true;
  const label = btn.textContent;
  btn.textContent = '…';
  const body = new FormData();
  body.append('id', btn.dataset.upsellVariant);
  body.append('quantity', '1');
  const sectionIds = Array.from(document.querySelectorAll('cart-items-component')).map((el) => el.dataset.sectionId).filter(Boolean);
  if (sectionIds.length) body.append('sections', sectionIds.join(','));
  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'cart',
    lines: [{ merchandiseId: btn.dataset.upsellVariant, quantity: 1 }],
    promise: deferred.promise,
  }));
  try {
    const res = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body,
    });
    const json = await res.json();
    if (json.status) throw new Error(json.description || json.message || 'Could not add');
    const cart = await fetch('/cart.js').then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'cc-cart-upsell', sourceId: 'cc-cart-upsell', itemCount: 1, productId: null, sections: json.sections, didError: false },
    });
  } catch (err) {
    deferred.reject(err);
    btn.disabled = false;
    btn.textContent = label;
  }
});
